"use client"

import Image from "next/image"
import { useRouter } from "next/navigation"

import BackgroundNotFound from "@/shared/assets/images/notfound-bg.png"
import ShapeNotFound from "@/shared/assets/images/notfound-shape.png"
import { Heading1 } from "@/shared/components/Heading1/Heading1"
import { Heading3 } from "@/shared/components/Heading3/Heading3"
import { Button } from "@/shared/shadcn/ui/button-old"

export default function NotFoundPage() {
  const router = useRouter()
  return (
    <section className="flex flex-col items-center justify-center relative">
      <Heading1 className="text-[64px] font-extrabold">404</Heading1>
      <Heading3 className="text-[32px] font-medium">
        We’re working on it!
      </Heading3>
      <div className="relative">
        <Image
          alt="404"
          height={600}
          priority
          quality={100}
          src={ShapeNotFound}
          width={600}
        />
        <div className="absolute top-10 right-28">
          <Image
            alt="404"
            height={400}
            priority
            quality={100}
            src={BackgroundNotFound}
            width={400}
          />
        </div>
      </div>
      <Button
        className="bg-[#FFFAE6] border-[#4258ED] border-[1.5px] text-[#4258ED] px-9 -mt-10 z-10"
        style={{ borderRadius: "16px" }}
        variant={"default"}
        onClick={() => router.back()}
      >
        Go Home
      </Button>
    </section>
  )
}
